import styled from 'styled-components'

import { theme } from '@/styles/theme'

import { PDFIcon } from '@/components/elements/Icon/PDF'

type Props = {
  url: string
}

export const PDFLink = ({ url }: Props) => {
  return (
    <Anchor href={url} target="_blank">
      <PDFIcon />
      PDF
    </Anchor>
  )
}

const Anchor = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 198px;
  height: 50px;
  font-size: 18px;
  line-height: 26px;
  letter-spacing: 0;
  color: ${theme.colors.trialBlue};
  border: 1px solid ${theme.colors.trialBlue};
  border-radius: 29px;
  transition: 0.3s;

  &:hover {
    background: ${theme.colors.trialBlue};
    border-color: ${theme.colors.trialBlue};
    color: #ffffff;

    > svg {
      fill: #ffffff;
    }
  }

  @media screen and (max-width: 1047px) {
    position: relative;

    > svg {
      position: absolute;
      left: 21px;
    }
  }
`
